import { TLC_CONSTANTS } from "../../../../js/lib/tlc-constants";
import { TemplateEngine } from "../../../../js/lib/TemplateEngine";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCEvents } from "../../../../js/lib/events/events";
import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { DialogManager } from "../../Managers/DialogManager";
import { AvailabilityFactory } from "../../availability/AvailabilityFactory";
import { EventableMixin } from "../../events/EventableMixin";
import { ApplicationData } from "../ApplicationData";
import { EResourcesAvailabilityClientManager } from "../ClientManagers/EResourcesAvailabilityClientManager";
import { LoginClientManager } from "../ClientManagers/LoginClientManager";
import { SimpleErrorDialog } from "../controls/simpleErrorDialog";
import { SuccessMessageControl } from "../controls/successMessageControl";
import { LS2PAC_Utils } from "../utils/Utils";
import { eResourceRedirect } from "../../../../js/main/eResourceRedirect";
import { AccountHolder } from "@tlc/ls2pac/components/Account";


export class BT_EResourceRequestView {
	constructor(options) {
		options = options || {};

		$.extend(true, this, {
			id: LS2PAC_CONSTANTS.Ids.eResourceCheckouts.eResourceCheckoutForm,
			formatSelectionId: LS2PAC_CONSTANTS.Ids.eResourceCheckouts.eResourceFormatSelectionDialog,
			holdFormId: LS2PAC_CONSTANTS.Ids.eResourceCheckouts.eResourceHoldForm,
			downloadAgainDialogId: LS2PAC_CONSTANTS.Ids.eResourceCheckouts.eResourceDownloadAgainSuccessDialog,
			events: [
				LS2PAC_CONSTANTS.Events.onAttemptEResourceCheckout,
				LS2PAC_CONSTANTS.Events.onEResourceCheckoutResponse,
				LS2PAC_CONSTANTS.Events.onEResourcePlaceHoldResponse,
				LS2PAC_CONSTANTS.Events.onAttemptEResourceFormatSelection,
				LS2PAC_CONSTANTS.Events.onAttemptOverdriveDownload,
				LS2PAC_CONSTANTS.Events.onAttemptEResourceRenew,
				LS2PAC_CONSTANTS.Events.onEResourceRenewResponse,
				LS2PAC_CONSTANTS.Events.onAttemptEResourceReturn,
				LS2PAC_CONSTANTS.Events.onEResourceReturnResponse,
				LS2PAC_CONSTANTS.Events.onGetEResourceFormatResponse
			],
			checkoutTemplateUrl: "tmpl/eResourceCheckouts/bt_checkout_dialog.html",
			formatSelectionTemplateUrl: "tmpl/eResourceCheckouts/bt_format_selection_dialog.html",
			overdriveIFrameDialogUrl: "tmpl/eResourceCheckouts/overdrive_iframe_dialog.html",
			checkoutSuccessTemplateUrl: "tmpl/eResourceCheckouts/bt_checkout_success_dialog.html",
			checkoutLaterSuccessTemplateUrl: "tmpl/eResourceCheckouts/bt_checkout_later_success_dialog.html",
			checkoutSuccessAutoSyncTemplateUrl: "tmpl/eResourceCheckouts/bt_checkout_success_auto_sync_dialog.html",
			checkoutRedirectSuccessTemplateUrl: "tmpl/eResourceCheckouts/bt_checkout_redirect_success_dialog.html",
			checkoutRedirectFailureTemplateUrl: "tmpl/eResourceCheckouts/bt_checkout_redirect_failure_dialog.html",
			downloadAgainSuccessTemplateUrl: "tmpl/eResourceCheckouts/bt_redownload_again_success_dialog.html",
			holdTemplateUrl: "tmpl/eResourceCheckouts/bt_hold_dialog.html",
			resource: null,
			currentLoan: null,
			userEmail: null,
			invalidUser: false,
			hasItemsOverdue: false,
			hasUnpaidFines: false,
			hasExpiredCard: false
		}, options);

		this.validationObject = {
			fields: [
				{
					selector: "#" + this.holdFormId + "_email",
					required: true,
					validators: [
						{
							type: TLC_CONSTANTS.ValidatorType.email,
							message: ApplicationData.language.eResourceHoldsValidationError
						}
					]
				}
			]
		};

		this.userEmail = (ApplicationData.getCurrentUser() != null) ? ApplicationData.getCurrentUser().email : "";

		this.addEvents();
		AccountHolder.subscribe(({user}) => {
			if(user) {
				this.userEmail = user.email;
			}
		});
	}
	getAvailabilityForOneEResource(event) {
		var _this = this;
		var availabilityHasChanged = false;

		EResourcesAvailabilityClientManager.getDownloadableItemAvailability({
			downloadableResources: [event.resource],
			resources: [event.resource],
			callCanAbort: false,
			throwResponseEvent: true,
			callback: function (newResource) {
				event.resource = newResource[0];

				_this.checkForInvalidUser(event);

				AvailabilityFactory.getDisplayObject(event.resource);

				if (_this.currentAvailability != event.resource.availability) {
					availabilityHasChanged = true;
				}

				if (_this.invalidUser) {
					var message = ApplicationData.language.eResourceInvalidUserMessage;

					if (_this.hasItemsOverdue) {
						message = ApplicationData.language.eResourceOverdueItemsMessage;
					} else if (_this.hasUnpaidFines) {
						message = ApplicationData.language.eResourceUnpaidFinesMessage;
					} else if (_this.hasExpiredCard) {
						message = ApplicationData.language.eResourceExpiredCardMessage;
					}

					_this.openErrorDialog(message);
				} else {
					if (availabilityHasChanged) {
						_this.openAvailabilityChangeDialog(ApplicationData.language.eAvailabilityLoginChange, function () {
							_this.determineCheckoutOrHold(event);
						});
					} else {
						_this.determineCheckoutOrHold(event);
					}
				}
			}
		});
	}
	checkForInvalidUser(event) {
		var _this = this;

		$.each(event.resource.eAvailabilities, function (index, availabilitySource) {
			if (availabilitySource.invalidUser) {
				_this.invalidUser = true;
				_this.hasItemsOverdue = availabilitySource.hasItemsOverdue;
				_this.hasUnpaidFines = availabilitySource.hasUnpaidFines;
				_this.hasExpiredCard = availabilitySource.hasExpiredCard;
			}
		});
	}
	openAvailabilityChangeDialog(message, callback) {
		DialogManager.show({
			content: message,
			okText: ApplicationData.language.ok,
			dialogTitle: ApplicationData.language.eAvailabilityChangeDialogTitle,
			showCancel: false,
			callback: function () { },
			closeCallback: function () {
				if (callback) {
					callback();
				}
			}
		});
	}
	openErrorDialog(message) {
		SimpleErrorDialog.show(message);
	}
	determineCheckoutOrHold(event) {
		var _this = this;

		_this.resource = event.resource;
		if (_this.resource.eResourceHasAvailability || event.referrer == "holds") {
			if (_this.resource.eResourceFormats.length > 0) {
				_this.prepareCheckoutDialog();
			} else {
				SimpleErrorDialog.show(ApplicationData.language.eResourceNoFormatsMessage);
			}

		} else {
			_this.prepareHoldDialog();
		}
	}
	/**
	 * HOLDS CODE
	 */
	prepareHoldDialog() {
		var _this = this;
		TemplateEngine.compile(this.holdTemplateUrl, {
			resource: this.resource,
			userEmail: this.userEmail,
			eResourceFormats: this.resource.eResourceFormats
		}, function (content) {
			_this.setUpHoldDialog(_this, content, false);
		});
	}
	setUpHoldDialog(_this, content, showErrorMessage) {
		DialogManager.show({
			content: content,
			buttons: "",
			dialogTitle: ApplicationData.language.placeARequestPrefix + " " + ApplicationData.language.request,
			submitCallback: function (event) { },
			callback: function () {
				_this.addDomEventsForHoldForm();
			}
		});
	}
	submitHold(event) {
		TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onEResourcePlaceHold, {
			resource: this.resource
		});

	}
	closeHoldDialog() {
		DialogManager.close();
	}
	handleHoldSuccess(_this, message) {
		SuccessMessageControl.show(message);
	}
	toggleHoldButtons(on) {
		var $form = $("#" + this.holdFormId);
		if (on) {
			$form.find(".toggleButton").removeClass(LS2PAC_CONSTANTS.CssClasses.disabled);
		} else {
			$form.find(".toggleButton").addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
		}

	}
	addDomEventsForHoldForm() {
		var $form = $("#" + this.holdFormId), _this = this;

		//	$form.on( "change", "input:radio", function() {
		//		_this.toggleHoldButtons( true );
		//	} );
		$form.on("click", ".placeHold", function (event) {
			_this.startSpinner("eResourceHoldForm");
			_this.submitHold(event);
			return false;
		});

	}
	handleHoldsError(message) {
		SimpleErrorDialog.show(message);
	}
	startSpinner(id) {
		$("#" + id).spin("large");
	}
	prepareFormatSelectionDialog(resource, callback) {
		var _this = this;
		TemplateEngine.compile(_this.formatSelectionTemplateUrl, resource, function (content) {
			_this.setUpFormatSelectionDialog(_this, content, false);
		});
	}
	setUpFormatSelectionDialog(_this, content, showErrorMessage) {
		DialogManager.show({
			content: content,
			buttons: "",
			dialogTitle: ApplicationData.language.eResourceDownloadAgain,
			submitCallback: function (event) { },
			callback: function () {
				_this.addDomEventsForFormatSelectionForm();
			}
		});
	}
	prepareOverdriveIFrameDialog(resource, callback) {
		var _this = this;
		TemplateEngine.compile(_this.overdriveIFrameDialogUrl, resource, function (content) {
			_this.setUpOverdriveIFrameDialog(_this, content, false);
		});
	}
	setUpOverdriveIFrameDialog(_this, content, showErrorMessage) {
		DialogManager.show({
			content: content,
			buttons: "",
			dialogTitle: ApplicationData.language.checkoutEResourceDialogTitle,
			submitCallback: function (event) { }
		});
	}
	addDomEventsForFormatSelectionForm() {
		var $form = $("#" + this.formatSelectionId), _this = this;

		$form.on("change", "input:radio", function (event) {
			_this.format = $(event.currentTarget).data("format");

			_this.flipToggleButtons(true, _this.formatSelectionId);
		});

		$form.on("click", ".okButton", this.onClickDownloadAgain(_this));
		$form.find("input:radio").eq(0).trigger("click"); //Auto select first option by default
	}
	onClickDownloadAgain(_this) {
		return function (event) {
			_this.startSpinner(_this.id);
			_this.flipToggleButtons(false, LS2PAC_CONSTANTS.Ids.eResourceCheckouts.eResourceFormatSelectionDialog);

			var loan = $.extend({}, _this.currentLoan);

			TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onRedownloadFormatSelected, {
				loan: loan,
				format: _this.format
			});

			_this.rebuildResourceAndHandleResponse(loan);

			return false;
		};
	}
	rebuildResourceAndHandleResponse(event) {
		event.resource = this.resource = this.currentLoan;
		event.itemId = this.currentLoan.itemId;
		event.service = this.currentLoan.eresourceService || this.currentLoan.service;
		event.url = eResourceRedirect(event.itemId, event.service);

		this.prepDownloadAgainSuccessDialog(event);
	}
	/**
	 * FORMAT SELECTION CODE ENDS
	 */
	/**
	 * CHECKOUTS CODE
	 */
	prepareCheckoutDialog() {
		var _this = this;
		TemplateEngine.compile(this.checkoutTemplateUrl, this.resource, function (content) {
			_this.setUpCheckoutDialog(_this, content, false);
		});
	}
	setUpCheckoutDialog(_this, content, showErrorMessage) {
		DialogManager.show({
			content: content,
			buttons: "",
			dialogTitle: ApplicationData.language.checkoutEResourceDialogTitle,
			submitCallback: function (event) { },
			callback: function () {
				_this.addDomEventsForCheckoutForm();
			}
		});
	}
	flipToggleButtons(on, id) {
		id = id || this.id;
		var $form = $("#" + id);

		if (on) {
			$form.find(".toggleButton").removeClass(LS2PAC_CONSTANTS.CssClasses.disabled);
		} else {
			$form.find(".toggleButton").addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
		}
	}
	addDomEventsForCheckoutForm($dialog) {
		var $form = $("#" + this.id), sync = false, format = "", _this = this;

		$form.on("change", "input:radio", function (event) {
			sync = false;
			format = $(event.currentTarget).data("format");

			if (format == LS2PAC_CONSTANTS.EResourceFormats.acoustik || format == LS2PAC_CONSTANTS.EResourceFormats.blio) {
				sync = true;
			}
			_this.flipToggleButtons(true);
		});

		$form.on("click", ".okButton", this.onClickOK(this));
		$form.find("input:radio").eq(0).trigger("click"); //Auto select first option by default
	}
	cancelAction() {
		DialogManager.close();
	}
	onClickOK(_this) {
		return function (event) {
			_this.startSpinner("eResourceCheckoutForm");
			_this.onPlaceCheckout();
			return false;
		};
	}
	getFormatByFormId(id) {
		return $("#" + id).find('input[name="checkoutFormat"]:checked').val();
	}
	onPlaceCheckout() {
		this.flipToggleButtons(false);
		TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onEResourceCheckout, {
			resource: this.resource,
			format: this.getFormatByFormId(this.id)
		});
	}
	handleCheckoutResponse(event) {
		event.url = eResourceRedirect(event.itemId, event.service);
		event.formatDisplayName = this.getMessageByMessageTokenString(event.formatServiceToken);

		if (event.autoSync == true) {
			this.prepSuccessfulAutoSyncDialog(event);
		} else {
			this.prepSuccessfulCheckoutDialog(event);
		}
	}
	handleCheckoutSuccess(_this, content, event) {
		_this = this;
		this.openCustomDialog({
			content: content,
			dialogTitle: ApplicationData.language.checkoutEResourceDialogTitle,
			buttons: "",
			callback: function () {
				var $view = $('.eResourceCheckoutForm');

				$view.on('click', '.downloadNow', function () {
					if (event.service === "overdrive") {
						_this.prepareOverdriveIFrameDialog(event);
					} else {
						window.open(eResourceRedirect(event.itemId, event.service), "_blank");
						DialogManager.close();
					}
				});

				$view.on('click', '.close', function () {
					DialogManager.close();
				});
			}
		});
	}
	handleRedirectCheckout(_this, content, event) {
		this.openCustomDialog({
			content: content,
			dialogTitle: ApplicationData.language.checkoutEResourceDialogTitle,
			buttons: "",
			callback: function () { }
		});
	}
	handleDownloadAgainSuccessDialog(_this, content, event) {
		this.openCustomDialog({
			content: content,
			dialogTitle: ApplicationData.language.eResourceDownloadAgain,
			buttons: "",
			callback: function () {
				$("#" + LS2PAC_CONSTANTS.Ids.eResourceCheckouts.eResourceDownloadAgainSuccessDialog).on('click', '.downloadNow', function (e) {
					DialogManager.close();
				});
			}
		});
	}
	handleCheckoutSuccessDownloadLater(_this, content, event) {
		this.openCustomDialog({
			content: content,
			buttons: "",
			dialogTitle: ApplicationData.language.checkoutEResourceDialogTitle
		});
	}
	handleCheckoutSuccessAutoSync(_this, content, event) {
		this.openCustomDialog({
			content: content,
			buttons: "",
			dialogTitle: ApplicationData.language.eResourceAutoSyncTitle
		});
	}
	prepSuccessfulCheckoutDialog(event) {
		var _this = this;
		TemplateEngine.compile(this.checkoutSuccessTemplateUrl, event, function (content) {
			_this.handleCheckoutSuccess(_this, content, event);
		});
	}
	prepSuccessfulAutoSyncDialog(event) {
		var _this = this;
		TemplateEngine.compile(this.checkoutSuccessAutoSyncTemplateUrl, event, function (content) {
			_this.handleCheckoutSuccessAutoSync(_this, content, event);
		});
	}
	prepSuccessfulLaterCheckoutDialog(event) {
		var _this = this;
		TemplateEngine.compile(this.checkoutLaterSuccessTemplateUrl, event, function (content) {
			_this.handleCheckoutSuccessDownloadLater(_this, content, event);
		});
	}
	prepDownloadAgainSuccessDialog(event) {
		var _this = this;
		TemplateEngine.compile(this.downloadAgainSuccessTemplateUrl, event, function (content) {
			_this.handleDownloadAgainSuccessDialog(_this, content, event);
		});
	}
	startDownload(event, id) {
		id = id || this.id;

		if (!event.useRedirectForUrl) {
			LS2PAC_Utils.downloadFile(event.url);
		}
	}
	handleCheckoutError(message) {
		SimpleErrorDialog.show(message);
	}
	openCustomDialog(options) {
		var _this = this, defaultOptions = {
			content: "",
			okText: ApplicationData.language.ok,
			showCancel: false,
			dialogTitle: "",
			submitCallback: function () { },
			callback: function () { }
		};

		var mergedOptions = $.extend({}, defaultOptions, options);

		DialogManager.show(mergedOptions);
	}
	getMessageToken(messageTokenString) {
		if (messageTokenString) {
			return messageTokenString.replace(/</g, "").replace(/>/g, ""); //trim <>
		}
		return messageTokenString;
	}
	getMessageByMessageTokenString(messageTokenString) {
		var message = ApplicationData.language[this.getMessageToken(messageTokenString)];
		return message === undefined ? messageTokenString : message;
	}
}

BT_EResourceRequestView.prototype[LS2PAC_CONSTANTS.Events.onAttemptEResourceCheckout] = function ( event ) {
	var _this = this;

	TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onClickDownloadLink, {
		resource: event.resource
	});

	LoginClientManager.promptIfNotLoggedIn( function () {
		TLCLogger.log( LS2PAC_CONSTANTS.Events.onAttemptEResourceCheckout, event );

		// Storing current availability in the case that a place hold click results in a checkout dialog
		// for overdrive advantage libraries (more copies are available upon login)
		_this.currentAvailability = event.resource.availability;
		_this.invalidUser = false;

		if( event.resource.eResourceFormats.length > 0 || (event.resource.eResourceService != "overdrive" && event.referrer != "holds" ) ) {
			_this.determineCheckoutOrHold( event )
		} else {
			_this.getAvailabilityForOneEResource( event )
		}
	} );
};










BT_EResourceRequestView.prototype[LS2PAC_CONSTANTS.Events.onEResourcePlaceHoldResponse] = function ( event ) {
	var _this = this;
	this.closeHoldDialog();
	var errorMessage = ApplicationData.language.eResourceHoldsErrorMessage;
	var successMessage = ApplicationData.language.eResourceHoldsSuccessMessage;

	if( event.success ) {
		this.handleHoldSuccess( _this, successMessage )
	} else {
		if( event.message ) {
			errorMessage = this.getMessageByMessageTokenString( event.message );

			if( event.checkedOut ) {
				errorMessage = this.getMessageByMessageTokenString( "TitleAlreadyCheckedOutToken" );
			}
		}

		this.handleHoldsError( errorMessage );
	}
};








/**
 * HOLDS CODE ENDS
 */

/**
 * FORMAT SELECTION CODE
 */

BT_EResourceRequestView.prototype[LS2PAC_CONSTANTS.Events.onAttemptEResourceFormatSelection] = function ( event ) {
	var _this = this;

	TLCLogger.log( LS2PAC_CONSTANTS.Events.onAttemptEResourceFormatSelection, event );
	_this.currentLoan = event.currentLoan;

	if( _this.currentLoan.formatInfo.length > 1) {
		_this.prepareFormatSelectionDialog( _this.currentLoan );
	} else {
		var service = this.currentLoan.eresourceService || this.currentLoan.service;

		event.url = eResourceRedirect( this.currentLoan.itemId, service );

		var redirectWindow = window.open( event.url );
	}
};

BT_EResourceRequestView.prototype[LS2PAC_CONSTANTS.Events.onAttemptOverdriveDownload] = function ( event ) {
	var _this = this;

	TLCLogger.log( LS2PAC_CONSTANTS.Events.onAttemptOverdriveDownload, event );
	_this.currentLoan = event.currentLoan;
	_this.prepareOverdriveIFrameDialog( _this.currentLoan );
};
















BT_EResourceRequestView.prototype[LS2PAC_CONSTANTS.Events.onEResourceCheckoutResponse] = function ( event ) {
	var message = "",
		_this = this;

	if( event.success ) {
		_this.handleCheckoutResponse( event );
	} else {
		message = ApplicationData.language.checkoutEResourceErrorMessage;
		if( event.accountLocked ) {
			message = ApplicationData.language.eResourceAccountLockedMessage
		} else {
			if( event.invalidUser ) {
				message = ApplicationData.language.eResourceInvalidUserMessage
			} else {
				if( event.maxedOut ) {
					message = ApplicationData.language.PatronCannotCheckoutTitleToken;
				}
				if( event.checkedOut ) {
					message = ApplicationData.language.eResourceAlreadyCheckedOutErrorMessage;
				}
				if( event.itemNotAvailable ) {
					message = ApplicationData.language.eResourceItemNotAvailable;
				}
			}
		}

		this.handleCheckoutError( message );
	}
};















BT_EResourceRequestView.prototype[LS2PAC_CONSTANTS.Events.onAttemptEResourceRenew] = function ( event ) {
	var _this = this;

	// TODO: Kos - this is no longer being hit
	// the code remains due to the response logic being sound, and perhaps we'll use it in the future

	TLCLogger.log( LS2PAC_CONSTANTS.Events.onAttemptEResourceRenew, event );
	_this.currentLoan = event.currentLoan;

	TLCEvents.trigger( LS2PAC_CONSTANTS.Events.onEResourceRenew, {
		resource: this.currentLoan
	} );
};

BT_EResourceRequestView.prototype[LS2PAC_CONSTANTS.Events.onEResourceRenewResponse] = function ( event ) {
	if( event.success ) {
		SuccessMessageControl.show( ApplicationData.language.eResourceLoanHasBeenRenewed );
		AccountHolder.fetchAccountSummaryAndPatron(true);
	} else if( event.onHoldForAnotherUser ) {
		this.openErrorDialog( ApplicationData.language.eResourceLoanIsOnHold );
	} else if( event.renewalsNotAllowed ) {
		this.openErrorDialog( ApplicationData.language.eResourceLoanRenewalNotPermitted );
	} else if( event.maxedOut ){
		this.openErrorDialog( ApplicationData.language.PatronCannotCheckoutTitleToken );
	} else if( event.allCopiesOnHold ) {
		this.openErrorDialog( ApplicationData.language.eResourceAllCopiesOnHold );
	}
};

BT_EResourceRequestView.prototype[LS2PAC_CONSTANTS.Events.onAttemptEResourceReturn] = function ( event ) {
	var _this = this;

	TLCLogger.log( LS2PAC_CONSTANTS.Events.onAttemptEResourceReturn, event );
	_this.currentLoan = event.currentLoan;

	TLCEvents.trigger( LS2PAC_CONSTANTS.Events.onEResourceReturn, {
		resource: this.currentLoan
	} );
};

BT_EResourceRequestView.prototype[LS2PAC_CONSTANTS.Events.onEResourceReturnResponse] = function ( event ) {
	if( event.success ) {
		SuccessMessageControl.show( ApplicationData.language.eResourceLoanReturned );
		AccountHolder.fetchAccountSummaryAndPatron(true);
	} else {
		var message = this.getMessageByMessageTokenString( event.message );
		this.openErrorDialog( message );
	}
};



EventableMixin.call( BT_EResourceRequestView.prototype );
